import { t as tryCatch, q as chain, k as fold } from '../../../Either-48abb652.js';
import { a as identity, f as flow, p as pipe } from '../../../ReadonlyNonEmptyArray-0e481d0b.js';
import { Node_Type } from 'ricos-schema';
import { s as stringifyWithReplace } from '../../../fp-utils-24a5cc96.js';

/**
 * @since 2.10.0
 */
/**
 * Converts a JavaScript Object Notation (JSON) string into a `Json` type.
 *
 * @example
 * import * as J from 'fp-ts/Json'
 * import * as E from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe('{"a":1}', J.parse), E.right({ a: 1 }))
 * assert.deepStrictEqual(pipe('{"a":}', J.parse), E.left(new SyntaxError('Unexpected token } in JSON at position 5')))
 *
 * @since 2.10.0
 */
var parse = function (s) { return tryCatch(function () { return JSON.parse(s); }, identity); };

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const keyToId = (v) => (v == null ? void 0 : v.key) !== void 0 ? __spreadValues({ id: v.key }, v) : v;
const bulletToBulleted = (v) => v === "BULLET_LIST" ? Node_Type.BULLETED_LIST : v;
const appEmbedIdToItemId = (v) => (v == null ? void 0 : v.id) && (v == null ? void 0 : v.imageSrc) ? __spreadProps(__spreadValues({}, v), { itemId: v.id }) : v;
const replacer = (_, v) => pipe(v, keyToId, bulletToBulleted, appEmbedIdToItemId);
var preprocess = flow(
  stringifyWithReplace(replacer),
  chain(parse),
  fold(
    () => ({}),
    (res) => res
  )
);

export { preprocess as default };
//# sourceMappingURL=preprocess.js.map
